module.exports = __webpack_public_path__ + "img/icon15.972fa9df.png";